import EmailField from 'components/EmailField';
import { localizable } from 'components/Localization';
import { FooterContainer } from 'components/PanelFooter';
import { observer } from 'mobx-react';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component, Fragment } from 'react';

const defaultData = {
  email: '',
  phoneNumber: '',
  firstName: '',
  lastName: '',
  locale: '',
};

@localizable
@observer
export default class BuyerAgentInviteSection extends Component {
  componentDidMount() {
    const { agent, app } = this.props;
    const data = {
      ...defaultData,
      tenant: app.tenantConfig.agentRegistrationDefaultTenant,
    };
    console.log('data', data);
    agent.setData(data);
  }

  handleInvite = () => {
    const { agent } = this.props;
    agent.invite();
  };

  handleCancel = async () => {
    const { agent } = this.props;
    agent.close();
  };

  handleChanged = (field) => (value, _, customValue) => {
    const { agent } = this.props;
    agent.propChanged(field, value, customValue);
  };

  handleTitleChanged = (option, _, value) => {
    const { agent } = this.props;
    agent.titleChanged(option, value);
  };

  render() {
    const { agent, t } = this.props;
    //const config = app.tenantConfig;

    return (
      <Fragment>
        <Panel
          headerText={t('Invite Buyer Agent')}
          type={PanelType.medium}
          onDismiss={this.handleCancel}
          isOpen={true}
          isFooterAtBottom={true}
          closeButtonAriaLabel="Close"
          onRenderFooterContent={() => {
            return (
              <FooterContainer>
                <PrimaryButton text={t('Invite')} onClick={this.handleInvite} />
                {/* <Observer
                  render={() => (
                    <NotificationPreview
                      action={`/api/v1/buyer-agent/invite/notifications`}
                      trigger="button"
                      query={{
                        locale: this.props.intl.locale,
                      }}
                      data={{
                        saleId: sale.saleId,
                        data: agent.data,
                      }}
                    />
                  )}
                /> */}
                <DefaultButton text={t('Cancel')} onClick={this.handleCancel} />
              </FooterContainer>
            );
          }}
        >
          <div className="ms-Grid">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-lg6 ms-md12 ms-sm12">
                <EmailField
                  label={t('Email')}
                  value={agent.data.email}
                  iconProps={{ iconName: 'Mail' }}
                  required={true}
                  onChanged={this.handleChanged('email')}
                  validateOnLoad={false}
                  autoComplete="nope"
                  validateOnFocusOut
                />
              </div>
              <div className="ms-Grid-col ms-lg6 ms-md12 ms-sm12">
                <TextField
                  label={t('Phone number')}
                  placeholder="+49 150 0000 0000"
                  value={agent.data.phoneNumber}
                  iconProps={{ iconName: 'Phone' }}
                  required={true}
                  onChanged={this.handleChanged('phoneNumber')}
                  validateOnLoad={false}
                  errorMessage={
                    agent.phoneNumberError === ''
                      ? agent.phoneNumberError
                      : t(agent.phoneNumberError)
                  }
                  validateOnFocusIn={true}
                  validateOnFocusOut={true}
                  autoComplete="nope"
                  inputMode="tel"
                />
              </div>
            </div>

            {/* <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                <ComboBox
                  label={t('Salutation')}
                  name="salutation"
                  required={true}
                  allowFreeform={false}
                  autoComplete="nope"
                  onChanged={this.handleChanged('salutation')}
                  value={
                    agent.data.salutation
                      ? t(`salutation::${agent.data.salutation}`)
                      : ''
                  }
                  options={config.salutationTypes.map((key) => {
                    return { key: key, text: t(`salutation::${key}`) };
                  })}
                />
              </div>
              <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                <ComboBox
                  label={t('Title')}
                  name="title"
                  allowFreeform={true}
                  autoComplete="nope"
                  onChanged={this.handleTitleChanged}
                  value={
                    agent.data.title ? t(`title::${agent.data.title}`) : ''
                  }
                  options={[{ key: '', text: '' }].concat(
                    config.titleTypes.map((key) => {
                      return { key: key, text: t(`title::${key}`) };
                    })
                  )}
                />
              </div>
            </div> */}

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                <TextField
                  label={t('First name')}
                  value={agent.data.firstName}
                  onChanged={this.handleChanged('firstName')}
                  required={true}
                  validateOnLoad={false}
                  onGetErrorMessage={this.requiredValidation}
                  validateOnFocusOut
                  autoComplete="nope"
                />
              </div>
              <div className="ms-Grid-col ms-md12 ms-sm12 ms-lg6">
                <TextField
                  label={t('Last name')}
                  value={agent.data.lastName}
                  onChanged={this.handleChanged('lastName')}
                  required={true}
                  validateOnLoad={false}
                  onGetErrorMessage={this.requiredValidation}
                  validateOnFocusOut
                  autoComplete="nope"
                />
              </div>
            </div>

            {/* {config.localeCodes.length >= 1 && (
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-lg12 ms-md12 ms-sm12">
                  <Dropdown
                    label={t('Locale')}
                    selectedKey={sale.saleEdit.locale}
                    onChanged={this.handleChanged('locale')}
                    options={config.localeCodes.map((key) => {
                      return { key: key, text: t(`locale::${key}`) };
                    })}
                  />
                </div>
              </div>
            )} */}
          </div>
        </Panel>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/BuyerAgentInviteSection/BuyerAgentInviteSection.jsx